<template>
  <div class=" fixed-top filter"> 
    <nav class="navbar-expand-sm navbar-dark " > 
      <div class="container-fluid d-flex justify-content-end "> 
        <template  v-if="button.show">
          <div>
            <router-link :to="button.link">
              <button class="btn btn-sm btn-outline-secondary filter-button" type="button" >New</button> 
              </router-link>
          </div>
         
        </template>
       
      </div>
    </nav>
  </div>
  
  
</template>
<script>
export default {
  name: "Filter",
  props:{
    button: {
      default() {
        return {
          show: false,
          link: "",
        };
      },
    },
  },
  data() {
    return {
     
    };
  },
  mounted() {
  
  },

  methods: {
    
  },
 
};
</script>
<style>

</style>